//
import developmentConfig from '#/net_configs/development.json'
import productionConfig from '#/net_configs/production.json'
import productionTestConfig from '#/net_configs/production-test.json'

//
var config;

if (process.env.NODE_ENV === 'development') {
    if (process.env.ziubao_shop_platform == 'ziubao') {
        config = developmentConfig;
    }
    else if (process.env.ziubao_shop_platform == 'ziubao_test') {
        config = productionTestConfig;
    }
}

if (process.env.NODE_ENV === 'production') {
    if (process.env.ziubao_shop_platform == 'ziubao') {
        config = productionConfig;
    }
    else if (process.env.ziubao_shop_platform == 'ziubao_test') {
        config = productionTestConfig;
    }
}

//
export default config;